import api from '../../lib/api';

const personas = [
  { value: 'brainstormer', label: 'Brainstormer', emoji: '\u{1F4A1}' },
  { value: 'challenger', label: 'Challenger', emoji: '\u{1F3AF}' },
  { value: 'devil', label: "Devil's Advocate", emoji: '\u{1F608}' },
  { value: 'adaptive', label: 'Adaptive', emoji: '\u{1F504}' },
];

export default function PersonaToggle({ conversationId, currentPersona, onChange }) {
  const handleChange = async (persona) => {
    try {
      await api.patch(`/conversations/${conversationId}/update/`, { persona });
      onChange(persona);
    } catch {
      // silent fail
    }
  };

  return (
    <div className="flex gap-1 p-2 overflow-x-auto">
      {personas.map((p) => (
        <button
          key={p.value}
          onClick={() => handleChange(p.value)}
          className={`flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap ${
            currentPersona === p.value
              ? 'bg-indigo-100 dark:bg-indigo-900/50 text-indigo-700 dark:text-indigo-400'
              : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700'
          }`}
        >
          <span>{p.emoji}</span>
          {p.label}
        </button>
      ))}
    </div>
  );
}
